import React from "react";
import { useNavigate } from "react-router-dom";

const AdminConfiguracionServicios = () => {
  const navigate = useNavigate();

  const opciones = [
    {
      titulo: "Opciones de incidencias",
      descripcion: "Gestiona el catálogo de tipos de incidencia disponibles al cerrar un servicio.",
      emoji: "⚠️",
      path: "/admin/configuracion-servicios/incidencias-opciones",
    },
    {
      titulo: "Opciones de reporte diario",
      descripcion: "Gestiona las categorías y subcategorías disponibles en el reporte diario.",
      emoji: "📋",
      path: "/admin/configuracion-servicios/reporte-opciones",
    },
    {
      titulo: "Opciones extras",
      descripcion: "Gestiona las tareas extra que puede añadir la asistenta al cerrar un piso.",
      emoji: "⭐",
      path: "/admin/configuracion-servicios/opciones-extras",
    },
    {
      titulo: "Razones \"No hecho\"",
      descripcion: "Gestiona los motivos disponibles cuando una tarea no se pudo realizar (limpieza, lavado, planchado).",
      emoji: "❌",
      path: "/admin/configuracion-servicios/opciones-no-hecho",
    },
    {
      titulo: "Media de supervisoras",
      descripcion: "Elige qué supervisoras cuentan para la media de gasto y tienen acceso al panel \"Ver datos compras\".",
      emoji: "📊",
      path: "/admin/configuracion-servicios/supervisoras-media",
    },
  ];

  return (
    <div style={{ minHeight: "100vh", background: "#f0f4f8", padding: "24px 16px" }}>
      <div style={{ maxWidth: 600, margin: "0 auto" }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: "none", border: "none", cursor: "pointer", fontSize: 15, color: "#3b82f6", fontWeight: 700, marginBottom: 20, padding: 0 }}
        >
          ← Volver
        </button>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: "#1e3a5f", marginBottom: 24 }}>
          ⚙️ Configuración de servicios
        </h2>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {opciones.map((op) => (
            <button
              key={op.path}
              onClick={() => navigate(op.path)}
              style={{
                background: "#fff",
                border: "2px solid #e2e8f0",
                borderRadius: 14,
                padding: "20px 22px",
                cursor: "pointer",
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                gap: 18,
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                transition: "border-color 0.15s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#3b82f6")}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#e2e8f0")}
            >
              <span style={{ fontSize: 36 }}>{op.emoji}</span>
              <div>
                <div style={{ fontSize: 17, fontWeight: 700, color: "#1e3a5f" }}>{op.titulo}</div>
                <div style={{ fontSize: 14, color: "#64748b", marginTop: 4 }}>{op.descripcion}</div>
              </div>
              <span style={{ marginLeft: "auto", fontSize: 20, color: "#94a3b8" }}>›</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminConfiguracionServicios;
